// const initialState = {
//     value: false
// }
// export const isMovieReducer = function (state = initialState, action) {
//     switch (action.type) {
//       case "TO_MOVIE":
//         return {
//             ...state,
//             value: true
//         }
//       case "TO_SHOW":
//         return {
//             ...state,
//             value: false
//         }
//       default:
//         return state;
//     }
//   };

//   export default isMovieReducer

import { createSlice } from '@reduxjs/toolkit'

export const mediaSlice = createSlice({
    name: 'media',
    initialState: {
        isMovie: false
    },
    reducers: {
        toggleMedia: state => {
            state.isMovie = !state.isMovie
        }
    }
})

export const { toggleMedia } = mediaSlice.actions

export default mediaSlice.reducer

// export const isFilm = state => state.mediaType.value

